import { css } from '@wrisk/styled-system'
import { animated, AnimatedComponent } from 'react-spring'
import styled from 'styled-components'

import { mdBumps } from '../../atoms'

export const AnimatedSnackBar: AnimatedComponent<'div'> = styled(animated.div)(
  css({
    p: mdBumps,
    mt: mdBumps,
    boxShadow: 'popupMenu',
    borderRadius: 1,
    zIndex: 1001,
    left: '50%',
    position: 'fixed',
    top: 0,
    minWidth: '380px',
    bg: 'chalk',
  }),
)
